module.exports = __webpack_public_path__ + "img/guide_img10.ae442cb0.jpg";